// ========== impersonate capability (remove this file + related blocks when done) ==========
export const IMPERSONATE = false;
export const EMAIL_IMPERSONATE = '';
// ========== end impersonate capability ==========
